import React from 'react';
import ToolIcon from '../ToolIcon/ToolIcon';
import './PlaceholderTool.css';

/**
 * PlaceholderTool Component
 * 
 * Renders a premium, Apple-inspired placeholder screen for modules
 * that are currently in development.
 * 
 * @component
 * @param {Object} props
 * @param {string} props.toolKey - The unique key of the tool (e.g. 'files', 'photos')
 * @param {string} props.title - The display title of the tool
 */
export default function PlaceholderTool({ toolKey, title }) {
    return (
        <div className="placeholder-tool-container">
            <div className="placeholder-card">
                <div className="placeholder-badge">In Entwicklung</div>
                <div className="placeholder-icon-wrapper">
                    <ToolIcon name={toolKey} mode="emoji" size={48} className="pulse-animation" />
                </div>
                <h2 className="placeholder-title">{title}</h2>
                <p className="placeholder-subtitle">
                    Wir arbeiten mit Hochdruck an diesem Modul. Schon bald steht dir hier die gewohnte Verwaltung für <strong>{title}</strong> zur Verfügung.
                </p>
                <div className="placeholder-divider" />
                <div className="placeholder-footer-info">
                    Modul-Schlüssel: <code>{toolKey}</code>
                </div>
            </div>
        </div>
    );
}
